<script>
  import { queryUserData } from '@button/ui/data';
  import GeoLocation from './GeoLocation.svelte';
  import GeoLocationOld from './GeoLocationOld.svelte';

  $: user = queryUserData();
</script>

{#if $user?.data?.object?.isGeolocationEnabled}
  <GeoLocation />
{:else}
  <GeoLocationOld />
{/if}
